const state = () => ({
  openTab: [],
  activeIndex: ''
})
const mutations = {
  add_tabs (state, data) {
    state.openTab.push(data)
  },
  delete_tabs (state, route) {
    let index = 0
    for (const gohh of state.openTab) {
      if (gohh.route === route) {
        break
      }
      index++
    }
    state.openTab.splice(index, 1)
  },
  set_active_index (state, index) {
    state.activeIndex = index
  }
}
const actions = {}
export default {
  state,
  mutations,
  actions
}
